import { render, staticRenderFns } from "./Gcash.vue?vue&type=template&id=410012b3&scoped=true&lang=pug"
import script from "./Gcash.vue?vue&type=script&lang=js"
export * from "./Gcash.vue?vue&type=script&lang=js"
import style0 from "./Gcash.vue?vue&type=style&index=0&id=410012b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410012b3",
  null
  
)

export default component.exports